<template>
    <div class="app-header-container">
        <div class="logo-container">
            <img class="client-logo" :src="clientLogo.dataUri"/>            
        </div>
        <ResponsiveNavigation v-if="showNavigation" :with-logout="true" @logout="logout"></ResponsiveNavigation>
        <div v-else class="logout-container">
            <button id="bG9nb3V0" class="button passive" @click="logout">
                <label>{{ $t('general.logout') }}</label>
            </button>
        </div>
    </div>
</template>

<script>
import ResponsiveNavigation from '@elements/ResponsiveNavigation.vue'

export default {
    inject: ["keycloak", "middlewarePortalFunctions", "clientLogo"],
    name: "app-header",
    data() {
        return {
            showNavigation: false
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            //check roles and hide navigation if invoices is not set
            const clientId = this.keycloak?.clientId
            const roles = this.keycloak.resourceAccess[clientId]?.roles || []
            const middlewarePortalFunctions = this.middlewarePortalFunctions?.roles || []
            if (roles.includes('invoices') || middlewarePortalFunctions.includes('invoices')) {
                this.showNavigation = true
            }
        },
        logout() {
            this.keycloak.logout();
        }
    },
    components: { ResponsiveNavigation }
}
</script>

<style lang="scss" scoped>
.app-header-container {
    padding: 0 16px;
    background-color: #fff;
    width: 100%;
    height: 60px;
    text-align: left;
    display: flex;
    align-items: center;
    box-shadow: 0px 2px 4px #00000011;
    display: flex;
    justify-content: space-between;

    > .logo-container {
        height: 100%;
        display: flex;
        align-items: center;
        width: 180px;
        > .client-logo {
            height: 65%;
        }
    }
}
</style>